module.exports = __webpack_public_path__ + "media/images/swissrail-logo-b5da4ec8.svg";